module.exports = __webpack_public_path__ + "img/logo.bfb43818.svg";